import ProceedOptions from "../errorBoundary/ProceedOptions.js";

function SearchNoResults({ query }) {
  return (
    <>
      <h4 className="mb-8">
        Riprova, nessun risultato trovato per <em>"{query}"</em>
      </h4>
      <ProceedOptions />
    </>
  );
}

export default SearchNoResults;
